export default __webpack_public_path__ + "static/media/boy.a3b8df14.svg";